module.exports = __webpack_public_path__ + "img/kjzy-xr.e4107d58.png";